import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrDeletePersonFilePayload } from 'api/actions/hr-delete-person-file/hr-delete-person-file-payload';
import { HrDeletePersonFilePathParameters } from 'api/actions/hr-delete-person-file/hr-delete-person-file-path-parameters';
import { HrDeletePersonFileResponse } from 'api/actions/hr-delete-person-file/hr-delete-person-file-response';

type HrDeletePersonFileQueryParameters = Record<string, any>;

/**
 * The path of the HrDeletePersonFile action.
 */
export const hrDeletePersonFileActionPath = new SweetPath<keyof HrDeletePersonFilePathParameters>(
  '/api/hr/people/{personId}/files/{personFileId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrDeletePersonFile actions.
 */
export default function createHrDeletePersonFileAction(axios: AxiosInstance) {
  return function hrDeletePersonFileAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrDeletePersonFilePathParameters;
    query?: HrDeletePersonFileQueryParameters;
    payload: HrDeletePersonFilePayload;
  }) {
    const path = hrDeletePersonFileActionPath.insert(parameters);

    return axios.request<HrDeletePersonFileResponse, HrDeletePersonFileResponse>({
      method: 'delete',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
